import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-account-trust-safety-card',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div
      class="bg-surface rounded-3xl p-5 sm:p-6 border border-border-subtle shadow-subtle antialiased relative overflow-hidden"
    >
      <div
        class="absolute right-0 top-0 w-20 h-full bg-success-soft opacity-20 pointer-events-none"
      ></div>

      <div class="flex items-center gap-3 mb-5 pb-3 border-b border-dashed border-border-subtle">
        <div
          class="w-8 h-8 rounded-xl bg-surface flex items-center justify-center text-text-primary shrink-0 shadow-subtle"
        >
          <i class="fa-solid fa-shield-halved text-[11px]"></i>
        </div>
        <div>
          <h4 class="text-[9px] font-black uppercase tracking-widest text-text-muted font-mono">
            {{ 'accountsInformation.trust.platformShield' | translate }}
          </h4>
          <h3 class="text-xs sm:text-sm font-black text-text-primary tracking-tight mt-0.5">
            {{ 'accountsInformation.trust.title' | translate }}
          </h3>
        </div>
      </div>

      <ul class="space-y-3">
        @for (check of checks; track check) {
          <li class="flex items-start gap-3 group">
            <div
              class="w-4 h-4 rounded-full bg-success-soft border border-success/20 flex items-center justify-center text-success shrink-0 mt-0.5 transition-colors group-hover:bg-success-soft"
            >
              <i class="fa-solid fa-check text-[9px] font-black"></i>
            </div>
            <span
              class="text-xs font-semibold text-text-secondary group-hover:text-text-primary transition-colors duration-150 leading-relaxed"
            >
              {{ check.startsWith('accountsInformation.') ? (check | translate) : check }}
            </span>
          </li>
        } @empty {
          <li
            class="py-2 flex items-center justify-center gap-2 border border-dashed border-border-subtle rounded-xl bg-surface-elevated text-center font-mono text-[10px] text-text-muted uppercase tracking-wider"
          >
            <i class="fa-solid fa-user-shield text-[11px] text-text-muted"></i>
            <span>{{ 'accountsInformation.empty.trustChecks' | translate }}</span>
          </li>
        }
      </ul>
    </div>
  `,
})
export class AccountTrustSafetyCardComponent {
  @Input() checks: string[] = [];
}
